<template lang="pug">

    campaign-form(
        ref="form"
        v-bind:segment='segment'
        v-bind:purchaser-models='companyModels'
        v-model="model"
    )

</template>

<script>
    import CampaignForm from './Form.vue'

    export default {

        components: { CampaignForm },

        computed: {

            model: {
                get() { return this.value },
                set(value) { this.$emit('input', value)}
            }

        },

        methods: {

            create() {
                return this.$store.dispatch('campaigns/create', { model: this.value })
            },

            async validate() {
                return await this.$refs.form.validate()
            },

            update() {
                return this.$store.dispatch('campaigns/update', { model: this.value })
            }

        },

        props: {

            segment: {
                type: [Boolean, String],
                default: true
            },

            companyModels: {
                type: Array,
                required: true
            },

            value: {
                type: Object,
                required: true
            }

        }

    }

</script>
